import { alpha } from "@mui/material";
import { pink } from "@mui/material/colors";
import axios from "axios";
import { allOption, selectOptKeyName } from "data/globalData";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { convertValueInCr, roundDecimalValueUptoTwo } from "utils/roundDecimalValue";

export const storeFilterColumns = [
	{
		name: "Channel",
		key: "channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Sub Channel",
		key: "sub_channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Store",
		key: "store",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},

	{
		name: "LFL/NEW BD",
		key: "lfl_nbd",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Store Type",
		key: "store_type",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
];
export const locationFilterColumns = [
	{
		name: "City",
		key: "city",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Tier",
		key: "tier",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "State",
		key: "state",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Region",
		key: "region",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
];
export const styleFilterCol = {
	name: "Style",
	key: "style",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	[selectOptKeyName]: {
		type: arrType,
		list: [
			// { name: allOption, key: allOption },
			{ name: "MAINLINE", key: "MAINLINE" },
			{ name: "GUILD", key: "GUILD" },
		],
		getOptionLabel: (opt) => ({ name: opt.style, key: opt.style }),
	},
};
export const colorFilterCol = {
	name: "Color",
	key: "color",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	[selectOptKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
	},
};
export const locationColumns = [
	{
		name: "State",
		key: "state",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
			getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
		},
	},
	{
		name: "City",
		key: "city",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
			getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
		},
	},
	{
		name: "Tier",
		key: "tier",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
			getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
		},
	},
];

export const imFilterColumnsObj = {
	brand: {
		name: "Brand",
		key: "brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [{ brand: "RARE RABBIT" }, { brand: "RAREISM", key: "RAREISM" }, { brand: "RAREONES", key: "RAREONES" }],
		},
	},
	sub_brand: {
		name: "Sub Brand",
		key: "sub_brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	season: {
		name: "Season",
		key: "season",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [
				{ season: "AW-24", key: "AW-24" },
				{ season: "AW-25", key: "AW-25" },
				{ season: "SS-25", key: "SS-25" },
				{ season: "SS-24", key: "SS-24" },
			],
		},
	},
	division: {
		name: "Division",
		key: "division",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	sub_category: {
		name: "Sub Category",
		key: "sub_category",
		dependency: { brand: true, category: true },
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	store_brand: {
		name: "Store Brand",
		key: "store_brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},

	sleeve: {
		name: "Sleeve",
		key: "sleeve",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},

	section: {
		name: "Section",
		key: "section",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	fashionability: {
		name: "Fashionability",
		key: "fashionability",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	occasion: {
		name: "Occasion",
		key: "occasion",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
};
//  const line1Color = " #70225465"; //#f1a6d6
// const line2Color = "#F3B4DC60";    //#702254
const line1Color = alpha(pink[900], 0.4); // 80% opacity
const line2Color = alpha(pink[100], 0.4); // 40% opacity

export const xAxisMonthDataCol = "month";
export const lineGraphTypes = {
	realized_Value: {
		name: "RV VS MONTH",
		key: "realized_Value",
		title: "",
		y: {
			label: "SALES (CR)",
			dataCol: "total_realised_value",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_total_realised_value",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 10000000);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_total_realised_value",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 10000000);
			},
		},
	},
	qty: {
		name: "QTY VS MONTH ",
		key: "qty",
		title: "",
		y: {
			label: "QTY (PCS) K",
			dataCol: "total_bill_quantity",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_total_bill_quantity",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 1000);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_total_bill_quantity",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 1000);
			},
		},
	},
	asp: {
		name: "ASP VS MONTH",
		key: "asp",
		title: "",
		y: {
			label: "ASP",
			dataCol: "asp",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_asp",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_asp",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	discount_percent: {
		name: "DISC(%) VS MONTH",
		key: "discount_percent",
		title: "",
		y: {
			label: "DISC %",
			dataCol: "discount_percent",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_discount_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_discount_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	gp_percent: {
		name: "GP(%) VS MONTH",
		key: "gp_percent",
		title: "",
		y: {
			label: "GP %",
			dataCol: "gp_percent",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_gp_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_gp_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	gp_value: {
		name: "GP VALUE VS MONTH",
		key: "gp_value",
		title: "",
		y: {
			label: "GP VALUE (CR)",
			dataCol: "gp_value",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_gp_value",
			getColVal: (val) => {
				return convertValueInCr(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_gp_value",
			getColVal: (val) => {
				return convertValueInCr(val);
			},
		},
	},
	avg_mrp_val: {
		name: "AVG MRP VALUE VS MONTH",
		key: "avg_mrp_val",
		title: "",
		y: {
			label: "AVG MRP VALUE",
			dataCol: "avg_mrp_val",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_avg_mrp_val",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_avg_mrp_val",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	upt: {
		name: "UPT VS MONTH",
		key: "upt",
		title: "",
		y: {
			label: "UPT",
			dataCol: "upt",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_upt",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_upt",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	aov: {
		name: "AOV VS MONTH",
		key: "aov",
		title: "",
		y: {
			label: "AOV",
			dataCol: "aov",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_aov",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_aov",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
};

export const getSaleImFields = async () => {
	const res = await axios.get(`/api/reports/get-sale-im-fields`);
	return res.data?.result;
};
